// src/app/core/services/push-notifications.service.ts
import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { HttpClientBase } from './http-client-base.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PushNotificationsService extends HttpClientBase {
  private readonly VAPID_PUBLIC_KEY = environment.push.vapidPublicKey;

  constructor(
    http: HttpClient,
    private swPush: SwPush,
  ) {
    super(http, 'push'); 
  }

  async subscribeToNotifications(userAgentInfo?: string) {
    try {
      if (!this.swPush.isEnabled) return;

      if (Notification.permission === 'denied') return;

      const subscription = await this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      });

      const json = subscription.toJSON() as any;

      const body = {
        endpoint: subscription.endpoint,
        expirationTime: json.expirationTime ?? null,
        keys: {
          p256dh: json.keys.p256dh,
          auth: json.keys.auth,
        },
        userAgent: userAgentInfo ?? navigator.userAgent,
      };

      await firstValueFrom(this.post<any>(body, 'subscribe', undefined, true));

    } catch (err) {
      console.warn('[Push] fallo pero no crítico', err);
    }
  }

  async unsubscribeFromNotifications() {
    if (!this.swPush.isEnabled) return;

    try {
      const sub = await firstValueFrom(this.swPush.subscription);
      if (!sub) {
        
        return;
      }

      const endpoint = sub.endpoint;

      await firstValueFrom(
        this.post<any>({ endpoint }, 'unsubscribe', undefined, true),
      );

      await sub.unsubscribe();

    } catch (err) {
      console.error('[Push] Error al desuscribirse de notificaciones', err);
    }
  }


  async sendTestNotification() {
    try {
      await firstValueFrom(
        this.post<any>({}, 'test', undefined, true)
      );
    } catch (err) {
      console.error('[Push] Error al pedir notificación de prueba', err);
    }
  }
}
